const ModalFooter = function (props: any) {
  const { children, size } = props;

  return <div className={`cb-modal__footer cb-modal__footer-${size}`}>{children}</div>;
};

export default ModalFooter;
